<template>
  <a-form-model
    ref="ruleForm"
    :model="form"
    class="demo__FormModal demo__align-left demo__margin-top--24"
  >
    <a-form-model-item ref="promo" prop="promo" :label="$t('Promo')">
      <a-input v-model="form.promo" class="demo__input" />
    </a-form-model-item>

    <a-form-model-item
      ref="promo"
      prop="promo"
      :label="$t('Where know about platform?')"
      class="demo__margin-top--16"
    >
      <div
        class="demo__flex demo__flex-middle demo__pointer demo__margin-top--12"
        v-for="invitation in invitationList"
        :key="invitation.key"
        @click="onChangeInvitation(invitation)"
      >
        <a-checkbox
          :checked="form.invitation === invitation.key"
          class="demo__Checkbox--big demo__Checkbox--white demo__margin-right--9"
        >
        </a-checkbox>
        <div
          class="demo__font--14 demo__weight--400 demo__color--black demo__line-height--normal"
        >
          {{ invitation.label }}
        </div>
      </div>
    </a-form-model-item>
    <a-form-model-item class="demo__margin-top--24">
      <div class="demo__flex demo__flex-middle demo__flex-between">
        <div
          class="demo__font--16 demo__weight--600 demo__color--black demo__flex demo__flex-middle"
          @click="$root.$emit('changeRegStep', 2)"
        >
          <i class="fa-regular fa-chevron-left demo__margin-right--12"></i>
          <div>
            {{ $t("Back") }}
          </div>
        </div>

        <a-button
          class="demo__button demo__button--base"
          @click="finishRegistration"
        >
          <span>
            {{ $t("Reg finish") }}
          </span>
          <!-- <i class="fa-light fa-chevron-right demo__margin-left--12"></i> -->
        </a-button>
      </div>
      <div
        class="demo__FormModal--result demo__margin-top--16"
        v-show="regResult"
      >
        {{ regResult ? regResult : false }}
      </div>
      <div class="demo__font--14 demo__weight--600 demo__margin-top--16">
        <span class="demo__color--black">
          {{ $t("Have account?") }}
        </span>
        <AuthLockBlock
          class="demo__color--brandPrimary demo__pointer demo__inline"
          >{{ $t("Submit") }}</AuthLockBlock
        >
      </div>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    form: {
      required: true,
      type: Object,
    },
    regResult: {
      required: false,
      type: String,
      default: undefined,
    },
  },
  computed: {
    ...mapGetters(["api"]),

    invitationList() {
      return [
        {
          key: "invitation_1",
          label: this.$t("invitation_1"),
          checked: false,
          ym_goal: "colleagues",
        },
        {
          key: "invitation_2",
          label: this.$t("invitation_2"),
          checked: false,
          ym_goal: "email",
        },
        {
          key: "invitation_3",
          label: this.$t("invitation_3"),
          checked: false,
          ym_goal: "search",
        },
        {
          key: "invitation_4",
          label: this.$t("invitation_4"),
          checked: false,
          ym_goal: "other",
        },
        {
          key: "invitation_5",
          label: this.$t("invitation_5"),
          checked: false,
          ym_goal: "socialnetwork",
        },
      ];
    },
  },
  created() {
    this.$accessModule("step3", this);
  },
  methods: {
    onChangeInvitation(invitation) {
      this.form.invitation = invitation.key;
    },
    finishRegistration() {
      this.$root.$emit("regFinish");
      if (window.ym) {
        this.$root.$emit("reachGoal", {
          goalName: "signup",
          data: {
            step: "complete",
            whereDidYouComeFrom: this.form.invitation.ym_goal,
          },
        });
        this.$debug(
          "YA METRICS: событие signup with step complete" +
            this.form.invitation.ym_goal,
          "ya_metric"
        );
      }
    },
  },
};
</script>
